import { Reveal } from "./Reveal";

const STEPS = [
  {
    num: "01",
    title: "Share your data.",
    body: "If you can put it in a spreadsheet, we can work with it. No integrations or technical setup required.",
    tag: "No integrations",
  },
  {
    num: "02",
    title: "We build a narrative for every person.",
    body: "Each recipient gets a narrative built around their specific activity and results. Not a mail merge \u2014 one crafted for them.",
    tag: "AI-generated, human approval",
  },
  {
    num: "03",
    title: "Your audience receives their Year in Review.",
    body: "Scrollable, mobile-first, shareable. You see who opened it and what resonated.",
    tag: "Mobile-first & interactive",
  },
];

export const HowItWorks = () => (
  <section className="bg-fwd-navy py-24 md:py-32 px-8 md:px-16 lg:px-20 relative overflow-hidden">
    {/* Decorative background text */}
    <div className="absolute bottom-[-40px] right-[-20px] font-display text-[18rem] font-normal text-white/[0.03] leading-none pointer-events-none select-none hidden lg:block">
      HOW
    </div>

    <div className="max-w-6xl mx-auto relative z-10">
      <Reveal>
        <span className="text-white/50 text-xs font-bold tracking-[0.2em] uppercase block mb-5">
          How It Works
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-[clamp(2.2rem,4vw,3.5rem)] font-normal leading-tight text-white mb-16">
          From your data to their narrative
          <br className="hidden md:block" /> in three steps.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12}>
            <div className="bg-white/[0.06] border border-white/10 rounded-lg p-8 md:p-10 h-full flex flex-col">
              <div className="font-display text-4xl text-white/15 leading-none mb-6">
                {step.num}
              </div>
              <h3 className="font-display text-xl text-white leading-snug mb-3">
                {step.title}
              </h3>
              <p className="text-white/50 text-[0.95rem] leading-relaxed font-light mb-5 flex-1">
                {step.body}
              </p>
              <span className="inline-block self-start text-[0.65rem] font-bold tracking-widest uppercase text-fwd-yellow border border-fwd-yellow/35 px-3 py-1 rounded-sm">
                {step.tag}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
